import React, { useContext, useState, createContext } from 'react'
import { useStore } from './StoreProvider';
import { useApolloClient } from '@apollo/client'
import { ORDERS } from 'query'

const orderContext = createContext(null);

const OrderProvider = ({ children }) => {
  const apolloClient = useApolloClient();
  const { selectedStoreID } = useStore();
  const [orderLoading, setOrderLoading] = useState('')

  const getOrders = async({ store_id = selectedStoreID, status = 'all', day_period = 1 }) => {
    setOrderLoading('get-orders')

    try {
      let result = await apolloClient.query({
        fetchPolicy: "network-only",
        query: ORDERS,
        variables: { store_id, status, day_period },
      })
      console.log(result)
      return { status: 'success', data: result.data.orders?.result }
    }
    catch (err) {
      console.error("orderProvider getOrders", err)
      return { status: 'failure', data: [] };
    } 
    finally {
      setOrderLoading('');
    }
  }

  return (
    <orderContext.Provider
      value={{
        getOrders,
        orderLoading,
      }}>
      {children}
    </orderContext.Provider>
  );
};

const useOrder = () => {
  const contx = useContext(orderContext);
  if (contx == null) {
    throw new Error('useOrder() called outside of a orderProvider?');
  }
  return contx;
};

export { OrderProvider, useOrder };


